import React, { Fragment, useState, useEffect } from "react";
import io from "socket.io-client";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import { getGifs, getGifsSearch } from "../../actions/gif";
import {
  getEmployerRecentEpisode,
  getCompanyEpisodes,
  getCompanyEpisode,
} from "../../actions/employerspotlight";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import EmployerEpisodesContainer from "../layout/Employers/EmployerEpisodesContainer";
import EmployerSpotlightVideo from "../layout/Employers/EmployerSpotlightVideo";
import CompanyImageDescriptionItem from "../layout/Companies/CompanyImageDescriptionItem";

import CompanyPositionItem from "../layout/Companies/CompanyPositionItem";
import CompanyChat from "../layout/Companies/CompanyChat";

import GreenSpinner from "../../img/Green_Spinner.gif";

let socket;

const EmployerOfWeek = ({
  match,
  auth: { user, channelid, jobtitle, location, verified },
  isAuthenticated,
  getGifs,
  gif: { gifs, loading },
  getEmployerRecentEpisode,
  getCompanyEpisodes,
  getCompanyEpisode,
  episode,
}) => {
  const ENDPOINT = "localhost:5000";

  const [showGIFs, setshowGIFs] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);
  const [text, setText] = useState("");
  const [foundGif, setGif] = useState("");
  const [flipCard, setflipCard] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [room, setRoom] = useState(match.params.companyname);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_green.png");
  const [active, setActive] = useState(true);
  const [showChat, setShowChat] = useState(true);
  const [showAuthentication, setShowAuthentication] = useState(true);

  const activeEpisode = (id) => {
    if (id === episode) {
      setActive(true);
    } else {
      setActive(false);
    }
  };

  useEffect(() => {
    getEmployerRecentEpisode();
    getCompanyEpisodes();
    getCompanyEpisode(match.params.companyname);
    getGifs();
    setRoom(match.params.companyname);
  }, [
    getGifs,
    getCompanyEpisode,
    getCompanyEpisodes,
    match.params.companyname,
    room,
  ]);

  useEffect(() => {
    if (user) {
      socket = io(ENDPOINT);

      socket.on("roomUsers", (room, users) => {
        console.log(room, users);
      });

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        channelid: user.channelid,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: match.params.companyname,
      });
    }

    return () => {
      if (socket) {
        socket.emit("leave");

        socket.disconnect();

        socket.off();
      }
    };
  }, [ENDPOINT, match.params.companyname, user]);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages([...messages, message]);
    });
  }, [messages]);

  const sendMessage = (e) => {
    e.preventDefault();
    if (message || foundGif !== "") {
      socket.emit(
        "chatMessage",
        message,
        foundGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setMessage("");
      setGif("");
      setshowGIFs(false);
    }
  };

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNav />}
      {!isAuthenticated && <LoggedOutNav />}
      {episode.companyloading ? (
        <div className="profile-error">
          <img src={GreenSpinner} />
        </div>
      ) : (
        <div className={showChat ? "flex-only-alt" : "flex-no-chat"}>
          <div className="side-container border-right grey">
            <div className="episodes">
              <div className="episode-link-container">
                <h1 className="episodes-desc-border">
                  <i className="fas fa-ticket-alt green mr-5"></i>Episodes
                </h1>
              </div>
              {episode.episodes &&
                episode.episodes.length > 0 &&
                episode.episodes.map((episode) => (
                  <div
                    className={
                      episode.companyname === match.params.companyname
                        ? "episodes-container-alt"
                        : "episodes-container"
                    }
                    key={episode._id}
                    onClick={() => {
                      getCompanyEpisode(match.params.companyname) &&
                        setRoom(episode._id) &&
                        activeEpisode(episode._id);
                    }}
                  >
                    <EmployerEpisodesContainer episode={episode} />
                  </div>
                ))}
            </div>
          </div>
          <div className="main-stream-content">
            <div className="video-chat">
              <EmployerSpotlightVideo episode={episode} showChat={showChat} />
              {!showChat && (
                <div className="showchaticon" onClick={() => setShowChat(true)}>
                  <i className="far fa-comment fa-2x green"></i>
                </div>
              )}
            </div>
            <div className="industry-company-section">
              <CompanyImageDescriptionItem episode={episode} />
            </div>
            <div className="positions-section">
              <CompanyPositionItem
                flipCard={flipCard}
                setflipCard={setflipCard}
                episode={episode}
              />
            </div>
            <div className="margin-top-alt"></div>
          </div>
          {showChat && (
            <CompanyChat
              messages={messages}
              message={message}
              setMessage={setMessage}
              gifs={gifs}
              setGif={setGif}
              foundGif={foundGif}
              showGIFs={showGIFs}
              setshowGIFs={setshowGIFs}
              gifSearch={gifSearch}
              setGifSearch={setGifSearch}
              sendMessage={sendMessage}
              text={text}
              setText={setText}
              episode={episode}
              setShowChat={setShowChat}
            />
          )}
        </div>
      )}
    </Fragment>
  );
};

EmployerOfWeek.propTypes = {
  auth: PropTypes.object.isRequired,
  getEmployerRecentEpisode,
  getGifsSearch: PropTypes.func.isRequired,
  getIndustryEpisodes: PropTypes.func.isRequired,
  getGifs: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  gif: state.gif,
  episode: state.employerweek,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getEmployerRecentEpisode,
  getCompanyEpisodes,
  getCompanyEpisode,
  getGifs,
  getGifsSearch,
})(EmployerOfWeek);
